// src/App.tsx
import React, { useEffect, useState } from "react";
import TransactionUploader from "./components/TransactionUploader/index";
import AnalysisResult from "./components/AnalysisResult";
import { db } from "./firebase";
import { collection, getDocs } from "firebase/firestore";
import './global.css';
import { fetchPromptsOnStartup } from "./services/api/langfuse";
import DotsSpinner from "./components/Spinners/DotsSpinner";
// import './App.css';

const App: React.FC = () => {
  const [analysisResult, setAnalysisResult] = useState<string | null>(null);
  const [condomini, setCondomini] = useState<string[]>([]);
  const [selectedCondominio, setSelectedCondominio] = useState<string>("");

  const [initializing, setInitializing] = useState(true);



  useEffect(() => {
    (async () => {
      try {
        await fetchPromptsOnStartup();
        console.log('Langfuse prompt ready');
      } catch (err) {
        console.error('Failed to init Langfuse:', err);
      } finally {
        setInitializing(false);
      }
    })();
  }, []);


  // Recupera tutti gli ID dei condomini dalla collezione "condomini"
  useEffect(() => {
    const fetchCondomini = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "condomini"));
        console.log("Number of documents:", querySnapshot.size);
        const condominiIDs: string[] = [];
        querySnapshot.forEach((doc) => {
          condominiIDs.push(doc.id);
        });
        console.log("Condomini recuperati:", condominiIDs);
        setCondomini(condominiIDs);
      } catch (error) {
        console.error("Errore durante il recupero dei condomini:", error);
      }
    };

    fetchCondomini();
  }, []);

  if (initializing) {
    return <div className="fixed inset-0 bg-white/70 flex items-center justify-center">
      <DotsSpinner size={80} strokeColor="#3498db" duration="1.5s" />
    </div>
  }

  return (
    <div className="App">
      <h1>Analisi Transazioni Bancarie</h1>
      <div>
        <h2>Seleziona il condominio</h2>
        <select
          value={selectedCondominio}
          onChange={(e) => setSelectedCondominio(e.target.value)}
        >
          <option value="">Scegli ID del condominio sul quale lavorare</option>
          {condomini.map((condominioId) => (
            <option key={condominioId} value={condominioId}>
              {condominioId}
            </option>
          ))}
        </select>
      </div>

      {/* Mostra il componente per il caricamento del CSV solo se un condominio è stato selezionato */}
      {selectedCondominio && (
        <TransactionUploader
          condominioId={selectedCondominio}
          setAnalysisResult={setAnalysisResult}
        />
      )}
      {analysisResult && <AnalysisResult result={analysisResult} />}
    </div>
  );
};

export default App;
